import React from "react";

const Navbar = () => (
	<nav className="bg-white shadow-lg sticky top-0 z-50">
		<div className="px-4 py-4 flex justify-between items-center">
			<div className="flex items-center space-x-1">
				<img src="./assets/diamondheirs.png" alt="" className="w-[60px]" />
				<h1 className="text-2xl md:text-3xl font-bold text-violet-800">
					Diamond Heirs
				</h1>
			</div>

			<div className="hidden sm:block space-x-6 font-bold md:text-2xl">
				<a href="#about" className="hover:text-violet-700">
					About
				</a>
				<a href="#services" className="hover:text-violet-700">
					Services
				</a>
				<a href="#contact" className="hover:text-violet-700">
					Contact
				</a>
			</div>

			{/* <div className="hidden md:block"></div> */}
		</div>
	</nav>
);

export default Navbar;
